module.exports = __webpack_public_path__ + "assets/img/7d1d1f350617af3cce5286195121553d.svg";